import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';
import { GpsMapPickerComponent } from '@kinet-open-network/client/shared/ui';

/**
 * Self-contained "Dodanie" (delivery) footer-block widget for orders: shows
 * who received the order, their email, the unloading stock code and — once
 * filled by the ca-gateway API — the GPS location where the order was
 * delivered, clickable to open a read-only map popup. Fully owns its own map
 * dialog state so the hosting detail component needs no map-related code.
 */
@Component({
  selector: 'kon-order-delivery-details-block',
  imports: [CommonModule, GpsMapPickerComponent],
  template: `
    <p class="break-words">
      <span class="font-normal text-gray-500">Dátum dodania:</span>&nbsp;{{
        deliveryDate() ? (deliveryDate() | date: 'dd.MM.yyyy HH:mm') : '--'
      }}<br />
      <span class="font-normal text-gray-500">Prijal:</span>&nbsp;{{
        recipientName() ?? '--'
      }}<br />
      <span class="font-normal text-gray-500">Email príjemcu:</span>&nbsp;{{
        recipientEmail() ?? '--'
      }}<br />
      <span class="font-normal text-gray-500">Sklad (zvoz):</span>&nbsp;{{
        unloadingStockCode() ?? '--'
      }}
      @if (point(); as p) {
        <br />
        <span class="font-normal text-gray-500">GPS:</span>&nbsp;
        <a
          class="cursor-pointer text-primary-600 hover:underline"
          (click)="mapVisible.set(true)"
        >
          {{ p.y | number: '1.5-5' }}, {{ p.x | number: '1.5-5' }}
        </a>
      }
    </p>
    <kon-gps-map-picker
      [(visible)]="mapVisible"
      [coordinates]="point()"
      [readonly]="true"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderDeliveryDetailsBlockComponent {
  recipientName = input<string | null>(null);
  recipientEmail = input<string | null>(null);
  deliveryDate = input<Date | string | null>(null);
  unloadingStockCode = input<string | null>(null);
  recipientGpsX = input<number | null>(null);
  recipientGpsY = input<number | null>(null);

  protected mapVisible = signal(false);
  protected point = computed(() => {
    const x = this.recipientGpsX();
    const y = this.recipientGpsY();
    return x != null && y != null ? { x, y } : null;
  });
}
